import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  TimefenceWeekComponent,
} from '../../../../../osp-ui/components/form/timefence/timefence-week/timefence-week.component';
import { ErrorComponent } from '../../../../../osp-ui/components/form/form-field/components/error/error.component';
import { AlarmSettingsFieldData } from '../../../contract/alarm-settings-field-data.contract';
import { AlarmSettingsStep2Controls } from '../contract/alarm-settings-step2-controls.contract';
import { AlarmRuleControl } from '../../../enums/alarm-rule-control.enum';

@Component({
  selector: 'osp-theft-protection-timefence-settings',
  standalone: true,
  imports: [
    TimefenceWeekComponent,
    ReactiveFormsModule,
    TranslateModule,
    ErrorComponent,
  ],
  templateUrl: './theft-protection-timefence-settings.component.html',
  styleUrls: ['./theft-protection-timefence-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TheftProtectionTimefenceSettingsComponent {
  private destroyRef = inject(DestroyRef);

  public settingsForm!: FormGroup<AlarmSettingsStep2Controls>;
  protected alarmSettingsFieldData: AlarmSettingsFieldData = {};
  public readonly controlNames = AlarmRuleControl;

  @Input() set form(form: FormGroup<AlarmSettingsStep2Controls>) {
    this.settingsForm = form;
    this.handleTimefenceWeekErrors();
  }

  @Input() set fieldData(fieldData: AlarmSettingsFieldData) {
    this.alarmSettingsFieldData = fieldData;
  }

  protected $timefenceWeekErrors = signal(
    this.settingsForm?.get(this.controlNames.SETTINGS_STEP2_TIMEFENCING_WEEK_DAY)?.errors,
  );

  protected tooltipPosition = 'top';

  private handleTimefenceWeekErrors(): void {
    const timefenceControl = this.settingsForm.get(this.controlNames.SETTINGS_STEP2_TIMEFENCING_WEEK_DAY);

    timefenceControl?.statusChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.$timefenceWeekErrors.set(timefenceControl.errors));
  }
}
